import { useState } from "react";
import { SearchFiltersModal } from "../shared/searchFiltersModal";

export const CamerasFiltersModal = ({
	showModal,
	handleClose,
	handleConfirm,
	initialCameraFilterStatus,
	initialAppliedFilters
}) => {
	const [cameraFilterStatus, setCameraFilterStatus] = useState(initialCameraFilterStatus)
	const [appliedFilters, setAppliedFilters] = useState(initialAppliedFilters)

	const clearLocalFilters = () => {
		setCameraFilterStatus(null)
		setAppliedFilters(null)
	}

	return (
		<SearchFiltersModal
			title="Filter Results"
			handleClose={ handleClose }
			handleConfirm={ () => handleConfirm({ cameraFilterStatus, appliedFilters }) }
			showModal={ showModal }
			key="cameras-filters-modal"
			handleReset={ clearLocalFilters }
		>
			<div className="w-100">
				<div className="d-flex flex-column mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">Status</label>
					<select
						value={ cameraFilterStatus === true ? "true" : cameraFilterStatus === false ? "false" : "" }
						onChange={ e => {
							const value = e.target.value === "true" ? true : e.target.value === "false" ? false : null
							setCameraFilterStatus(value)
							setAppliedFilters(prevState => {
								const updatedFilters = { ...prevState }
								if (value === null) {
									delete updatedFilters["Status"]
								} else {
									updatedFilters["Status"] = value ? "Active" : "Deactivated"
								}
								return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
							})
						} }
						className="border rounded px-2 py-1 w-100"
					>
						<option value="">All</option>
						<option value="true">Active</option>
						<option value="false">Deactivated</option>
					</select>
				</div>
			</div>
		</SearchFiltersModal>
	)
}
